module.exports = __webpack_public_path__ + "static/img/solve5.08ff033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/solve5.png
// module id = QP7b
// module chunks = 1